import { SvgStyled } from '../../components/Global/Atomics/SvgStyled';

const Information_sm = (props) => {
    const width = props.width ? props.width + 'px' : '20px';
    const height = props.height ? props.height + 'px' : '20px';

    return (
        <SvgStyled
            xmlns="http://www.w3.org/2000/svg"
            version="1.1"
            className={props.cssClasses ? `icon ${props.cssClasses}` : 'icon'}
            viewBox="0 0 20 20"
            fill={props.fill ? props.fill : 'none'}
            customColor={props.customColor}
            width={width}
            height={height}>
            <path
                d="M9 7C9 6.44772 9.44771 6 10 6C10.5523 6 11 6.44772 11 7C11 7.55229 10.5523 8 10 8C9.44771 8 9 7.55229 9 7Z"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M17.75 10C17.75 14.2802 14.2802 17.75 10 17.75C5.71979 17.75 2.25 14.2802 2.25 10C2.25 5.71979 5.71979 2.25 10 2.25C14.2802 2.25 17.75 5.71979 17.75 10ZM10 16.25C13.4518 16.25 16.25 13.4518 16.25 10C16.25 6.54822 13.4518 3.75 10 3.75C6.54822 3.75 3.75 6.54822 3.75 10C3.75 13.4518 6.54822 16.25 10 16.25ZM10 14.75C9.58579 14.75 9.25 14.4142 9.25 14L9.25 10C9.25 9.58579 9.58579 9.25 10 9.25C10.4142 9.25 10.75 9.58579 10.75 10V14C10.75 14.4142 10.4142 14.75 10 14.75Z"
            />
        </SvgStyled>
    );
};

export default Information_sm;
